import { useEffect, useState } from "react";
import { Container } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import dayjs from "dayjs";

import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionTitle from "../../components/AccordionTitle";
import { exportDownloadSingle } from "../../services/ExportService";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import SubTitle from "../../components/SubTitle";
import { isAdmin } from "../../services/UserService";

import { doService } from "../../services/ServiceHelper";

import { getTeacherRoster } from "../../services/ActivityService";
import { convertToYYYYMMDD } from "../../services/DateService";
import TableRowNoResults from "../../components/TableRowNoResults";
import { getPeriodName } from "../../services/SchoolService";

const DailyRoster = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [_activities, setActivities] = useState([]);
  const [showProgress, setShowProgress] = useState(false);

  const [_dateStart, setDateStart] = useState(dayjs());
  const [_searchPerformed, setSearchPerformed] = useState(false);

  useEffect(() => {}, []);

  const handleSearch = () => {
    setSearchPerformed(true);

    const date = convertToYYYYMMDD(_dateStart);
    setShowProgress(true);
    doService(getTeacherRoster(_school, _jwt, date), (results) => {
      const data = results.data;

      // setOpenPasses(results.data);
      console.log(data);
      setActivities(results.data);
      setShowProgress(false);
    });
  };

  const handleExport = () => {
    const exportRows = [];

    exportRows.push([
      "Date",
      "Period",
      "Activity",
      "Location",
      "Student Last Name",
      "Student First Name",
      "Grade",
      "Comment",
    ]);
    const date = convertToYYYYMMDD(_dateStart);

    for (const activity of _activities) {
      for (const student of activity.students) {
        exportRows.push([
          date,
          getPeriodName(_school, activity.period - 1),
          activity.name,
          activity.locationName,
          student.last_name,
          student.first_name,
          student.grade,
          student.comment,
        ]);
      }
    }

    exportDownloadSingle(`daily-roster-${date}.xlsx`, "Results", exportRows);
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Daily Teacher Roster" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Alert severity="info" sx={{ mt: 1, mb: 1 }}>
          <span className="emphasis">INSTRUCTIONS</span> - Select Date and Click
          SEARCH button to Search Rosters.
        </Alert>

        <Accordion defaultExpanded sx={{ mt: 1 }}>
          <AccordionSummary className="accordionHeader">
            <AccordionTitle text="Select Date" />
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} sx={{ pt: 2 }}>
              <Grid sx={{ pt: "0.5em !important" }} item xs={6} md={6}>
                <MobileDatePicker
                  value={_dateStart}
                  onChange={(newValue) => {
                    setDateStart(newValue);
                  }}
                />
              </Grid>
              <Grid sx={{ pt: "0.5em !important" }} item xs={6} md={6}>
                <Button
                  size="large"
                  onClick={handleSearch}
                  sx={{ ml: 1, mt: 0 }}
                  variant="contained"
                >
                  Search
                </Button>
                <Button
                  size="large"
                  onClick={handleExport}
                  sx={{ ml: 1, mt: 0 }}
                  variant="outlined"
                >
                  Export
                </Button>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        {_searchPerformed && (
          <Box sx={{ boxShadow: 1, p: 1, mt: 2 }}>
            <SubTitle text="Roster List" />

            <TableRowNoResults
              data={_activities}
              text="-- NO ACTIVITIES RETURNED --"
            />

            {_activities.map((activity) => (
              <Accordion disableGutters>
                <AccordionSummary className="accordionHeader">
                  <AccordionTitle
                    text={`${activity.period}: ${activity.name} (${activity.students.length})`}
                  />
                </AccordionSummary>
                <AccordionDetails>
                  {isAdmin(_jwt) && (
                    <>
                      Proctor: {activity.last_name}, {activity.first_name}
                    </>
                  )}
                  <List dense sx={{ pt: 0 }}>
                    <ListItem sx={{ pt: 0, pb: 0 }}>
                      <ListItemText
                        primary={"Location: " + activity.locationName}
                        sx={{ fontStyle: "italic" }}
                      />
                    </ListItem>
                    {activity.students.map((student) => (
                      <ListItem sx={{ pt: 0, pb: 0 }}>
                        <ListItemText
                          primary={
                            student.last_name + ", " + student.first_name
                          }
                        />
                      </ListItem>
                    ))}

                    {activity.students.length === 0 && (
                      <ListItem sx={{ pt: 0, pb: 0 }}>
                        <ListItemText primary="-- NO STUDENTS RETURNED --" />
                      </ListItem>
                    )}
                  </List>
                </AccordionDetails>
                {_activities.length === 0 && (
                  <Typography>-- NO ACTIVITIES RETURNED --</Typography>
                )}
              </Accordion>
            ))}
          </Box>
        )}
      </Container>
    </>
  );
};

export default DailyRoster;
